module.exports = __webpack_public_path__ + "img/plateup_01.3e2de4fe.jpg";